export default "/images/vendor/flag-icon-css/flags/4x3/cf.svg?617adc02abcee400496d073fbbd21515";